import React, { useEffect } from 'react'
import '../style/collage.css'
import img1 from '../images/g1.jpg'
import img2 from '../images/g2.jpg'
import img3 from '../images/g3.jpg'
import img4 from '../images/g4.jpg'
import img5 from '../images/g5.jpg'
import img6 from '../images/g6.jpg'
import img7 from '../images/g7.jpg'
import img8 from '../images/g8.jpg'
import img9 from '../images/g9.jpg'
import img10 from '../images/g10.jpg'
import CarouselGallery from './CarouselGallery'

const Collage = () => {
    const images = [
        img1,
        img2,
        img3,
        img4,
        img5,
        img6,
        img7,
        img8,
        img9,
        img10
    ];

    useEffect(() => {
        const handleImageLoad = (e) => {
            e.target.classList.add('loaded');
        };

        const images = document.querySelectorAll('.Collage img');
        images.forEach((img) => {
            if (img.complete) {
                img.classList.add('loaded');
            } else {
                img.addEventListener('load', handleImageLoad);
            }
        });

        return () => {
            images.forEach((img) => {
                img.removeEventListener('load', handleImageLoad);
            });
        };
    }, []);

    return (
        <div className='container'>
            <div className='ok' style={{ display: 'flex', justifyContent: 'center', marginTop: '25px', paddingTop: '25px' }} data-aos="fade-up" data-aos-offset="250" data-aos-duration="1500" mirror='true'>
                <h3 style={{ padding: '7px', paddingBottom:'50px', color:"#00415d" }}>Umang's Gallery</h3>
                <img src="https://www.svgrepo.com/show/286480/gallery.svg" width={'60px'} height={'60px'} alt="gallerys" />
            </div>
            {/* <div className="Collage effect-parent">
                {images.map((src, index) => (
                    <img key={index} src={src} alt={`Collage item ${index + 1}`} />
                ))}
            </div> */}
            <CarouselGallery/>
        </div>
    );
};

export default Collage;
